module.exports = __webpack_public_path__ + "static/img/指挥中心.02d2cda8.png";